<div class="content-wrapper">
  <div class="page-heading d-flex align-items-center gap-3">
    <button 
      class="btn btn-primary"
      (click)="back()">
      <i 
        class="fa-solid fa-arrow-left" 
        data-bs-toggle="Tooltip" 
        title="Go Back"
      ></i>
    </button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-abandon">
    <div class="form-abandon-heading d-flex justify-content-center">
      <h2>Edit Content</h2>
    </div>
    <!-- Edit Checkbox -->
    <div class="form-abandon-body">
      <div class="form-check mb-3">
        <input 
          type="checkbox" 
          class="form-check-input" 
          formControlName="isEdited" 
          id="editToggle"
          (change)="isEditedEnabled()" 
          [readOnly]="!isEditable" 
        />
        <label class="form-check-label" for="editToggle">Edit</label>
      </div>

      <!-- Title -->
      <input 
        type="text" 
        class="form-control mb-2" 
        formControlName="title" 
        placeholder="Title"
        [readOnly]="!isEditable" 
      />

      <!-- Content (rich text editor) -->
      <quill-editor 
        formControlName="content" 
        format="text" 
        [modules]="editorConfig" 
        placeholder="Enter content..."
        [readOnly]="!isEditable"
      ></quill-editor>
      <!-- Abandoned Note -->
      <textarea class="form-control my-2" formControlName="abandonedNote" placeholder="Abandoned Note"
      [hidden]="!isEditable"></textarea>
      <button type="submit" class="btn btn-primary mt-3">Save</button>
      &nbsp;
      <button type="submit" class="btn btn-secondary mt-3" (click)="back()">Cancel</button>
      </div>
  </form>
  <div *ngIf="!contentData">
    <app-loader></app-loader>
  </div>
</div>